export const VACATION_START_ATTR_ID = 'b702174b-f9e1-4ec4-97a3-78642eb46e3a';
export const VACATION_END_ATTR_ID = 'b6678658-e673-4782-9d0d-7eb15394d7e5';

export const FIRST_VACATION_START_ATTR_ID =
  '618b4c3d-b117-411f-b8e0-768ccddcf98a';
export const FIRST_VACATION_END_ATTR_ID =
  '11c46dd8-69c7-4fcb-8d61-f1b998223d7a';

export const SECOND_VACATION_START_ATTR_ID =
  'df831f36-2887-4e38-b821-5da41cc79ef2';
export const SECOND_VACATION_END_ATTR_ID =
  '75cf7a13-93cb-4ac0-a404-85baad279f3f';

export const THIRD_VACATION_START_ATTR_ID =
  '164c8694-a803-486e-881c-70e718a39279';
export const THIRD_VACATION_END_ATTR_ID =
  '5e8f489f-7308-4aca-99b9-0e64ad3fdf05';
export const THIRD_VACATION_TYPE_ATTR_ID =
  'a6eba3d1-a2f2-4b4d-a98a-42ea2d702e42';
export const THIRD_VACATION_DAYS_COUNT = '4e3ac7e3-64a1-439b-8cbb-3bbde7ea917b';

export const FOURTH_VACATION_START_ATTR_ID =
  '7e5bb0f1-5201-4f36-9b47-9e7d261dd792';
export const FOURTH_VACATION_END_ATTR_ID =
  '1bf5abc2-b941-4958-9ca7-3d002dbd382b';

export const FIFTH_VACATION_START_ATTR_ID =
  '007119c9-770f-4ec0-ae08-b924101f448f';
export const FIFTH_VACATION_END_ATTR_ID =
  '4a67438e-024e-4dc9-9a38-4c212ebfdf40';

export const BUTTON_TYPES = ['cancel', 'confirm', 'sign'] as const;
